const abortSignalByKey: Record<string, AbortController | null> = {};

/**
 * This function refreshes the AbortSignal for a given key.
 * It aborts existing signal and saves new one by key.
 *
 * @param {string} key - The key to identify the AbortController.
 * @returns {AbortSignal} - The new AbortSignal.
 */
export function abortAndRefreshSignalByKey(key: string): AbortSignal {
  abortSignalByKey[key]?.abort();
  const abortController = new AbortController();
  abortSignalByKey[key] = abortController;
  return abortController.signal;
}
